import React from 'react';
import { Link } from 'react-router-dom';

const TabItem = ({ item, isActive }) => {
  const Icon = item.icon;
  const navLabel = item.mobileLabel || item.label || item.name;
  return (
    <Link
      to={item.href}
      className='flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-2 py-1.5 text-center transition-all duration-200'
      style={{
        color: isActive ? 'var(--text-primary)' : 'var(--text-muted)',
        background: isActive ? 'var(--sidebar-active-bg)' : 'transparent',
      }}
      aria-current={isActive ? 'page' : undefined}
    >
      <span
        className='flex h-9 w-9 items-center justify-center rounded-xl transition-all duration-200'
        style={{
          background: isActive ? 'rgba(45, 212, 191, 0.18)' : 'transparent',
          color: isActive ? 'var(--brand-dark)' : 'var(--text-muted)',
        }}
      >
        <Icon className='h-[1.05rem] w-[1.05rem]' />
      </span>
      <span
        className='truncate text-[0.64rem] font-semibold tracking-[0.01em]'
        style={{ color: isActive ? 'var(--text-primary)' : 'var(--text-muted)' }}
      >
        {navLabel}
      </span>
    </Link>
  );
};

const AgentActionItem = ({ item }) => {
  const Icon = item.icon;
  return (
    <Link
      to={item.href}
      aria-label={item.label || 'Open campaign agent'}
      className='mobile-tour-campaign-agent-cta relative flex min-w-0 flex-1 items-start justify-center'
    >
      <span
        className='flex h-14 w-14 -translate-y-3 items-center justify-center rounded-full text-white shadow-lg transition-transform active:scale-95'
        style={{
          background: 'linear-gradient(135deg, var(--accent) 0%, var(--brand) 100%)',
          boxShadow: '0 12px 28px rgba(45, 212, 191, 0.45)',
        }}
      >
        <Icon className='h-6 w-6' strokeWidth={2.5} />
      </span>
    </Link>
  );
};

const MobileBottomNav = ({ navigation, isCurrentPath }) => {
  return (
    <div className='mobile-tabbar-wrap fixed inset-x-0 bottom-0 z-30 px-3 lg:hidden'>
      <nav
        className='mobile-tabbar mx-auto flex w-full max-w-md items-center gap-1 rounded-[1.5rem] px-2 py-1.5'
        aria-label='Primary mobile navigation'
      >
        {navigation.map((item) => {
          if (item.isAgentAction) {
            return <AgentActionItem key={item.name} item={item} />;
          }
          return (
            <TabItem key={item.name} item={item} isActive={isCurrentPath(item.href)} />
          );
        })}
      </nav>
    </div>
  );
};

export default MobileBottomNav;
